import { gql } from '@apollo/client';

export const MARK_SMS_ACTIVITIES_READ = gql`
  mutation MarkSmsActivitiesRead($vendorOpportunityId: ID!, $conversationSequenceNumber: Int!) {
    messaging {
      markSmsActivitiesRead(
        vendorOpportunityId: $vendorOpportunityId
        conversationSequenceNumber: $conversationSequenceNumber
      ) {
        success
        error
        entity {
          updatedCount
        }
      }
    }
  }
`;
